import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useAuditReports } from "@/hooks/use-audit-reports";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { Shield, Settings } from "lucide-react";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import { getActionLabel } from "@/lib/audit/action-labels";
import { CATEGORY_COLORS } from "@/lib/audit/action-categories";

const SYSTEM_ACTIONS = [
  'permission.grant',
  'permission.revoke',
  'role.create',
  'role.delete',
  'settings.update',
  'billing.settings_update',
  'company.settings_update',
];

export function SystemTab() {
  const { data: logs, isLoading } = useAuditReports({
    actions: SYSTEM_ACTIONS,
  });

  if (isLoading) {
    return (
      <div className="flex justify-center py-12">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Mudanças de Permissão</CardTitle>
            <Shield className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">
              {logs?.filter(log => log.action.startsWith('permission.')).length || 0}
            </div>
            <p className="text-xs text-muted-foreground mt-1">Permissões modificadas</p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Configurações Alteradas</CardTitle>
            <Settings className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">
              {logs?.filter(log => log.action.includes('settings')).length || 0}
            </div>
            <p className="text-xs text-muted-foreground mt-1">Configurações do sistema</p>
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Logs de Sistema</CardTitle>
        </CardHeader>
        <CardContent>
          {!logs || logs.length === 0 ? (
            <div className="text-center py-12 text-muted-foreground">
              <p>Nenhum registro de sistema encontrado</p>
            </div>
          ) : (
            <div className="border rounded-md">
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHead>Data/Hora</TableHead>
                    <TableHead>Usuário</TableHead>
                    <TableHead>Ação</TableHead>
                    <TableHead>Tipo</TableHead>
                    <TableHead>Empresa</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {logs.map((log) => {
                    const colors = CATEGORY_COLORS.system;
                    
                    return (
                      <TableRow key={log.id}>
                        <TableCell className="font-mono text-xs">
                          {format(new Date(log.created_at), 'dd/MM/yy HH:mm', { locale: ptBR })}
                        </TableCell>
                        <TableCell className="font-mono text-xs">
                          {log.actor_user_id?.substring(0, 8)}...
                        </TableCell>
                        <TableCell>
                          <Badge className={colors.badge} variant="outline">
                            {getActionLabel(log.action)}
                          </Badge>
                        </TableCell>
                        <TableCell>{log.entity_type}</TableCell>
                        <TableCell className="font-mono text-xs">
                          {log.company_id ? `${log.company_id.substring(0, 8)}...` : '-'}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
